import { Button, Input, Spinner } from "reactstrap";

const SearchBar = ({ searchId, handleInput, handleSearch, searchLoader }) => {
  return (
    <>
      <form className="d-flex mx-md-2" onSubmit={handleSearch}>
        <Input
          className="w-100 mr-3"
          placeholder="Search by Id"
          value={searchId}
          onChange={handleInput}
        />
        <Button type="submit" color="primary" disabled={!searchId}>
          {searchLoader ? <Spinner size={"sm"} /> : <i class="fas fa-search" />}
        </Button>
      </form>
    </>
  );
};

export default SearchBar;
